module.exports = __webpack_public_path__ + "img/f_1.5db6228.png";